import languages from "../locales/all.js"
window.scratchblocks.loadLanguages(languages)
